// Function to shuffle an array (Fisher-Yates shuffle)
function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}
var rebuyLoaded = false;
var aiProcessing = false;
var aiLoading = false;
var waitRebuy = setInterval(function () {
    if (typeof Rebuy != 'undefined') {
        if(Rebuy && Rebuy.SmartCart) {
            rebuyLoaded = true;
            clearInterval(waitRebuy);
        } 
    }
}, 10);
// Example: Fetch products, clear the cart, and add them to the cart using Rebuy Smart Cart API based on the selected amount.
function generateCart(totalAmount, clearCart) {
    if (rebuyLoaded){
        //Rebuy.SmartCart.hide();
        Rebuy.SmartCart.skip_open = true;
        aiProcessing = true;
        aiLoading = true;
        document.getElementById('snack-roulette-modal-header').style.display = 'none';
        document.getElementById('snack-roulette-modal-description').style.display = 'none';
        document.getElementById('snack-roulette-spinner').style.display = 'flex';  // Show spinner

        // Step 1: Clear the customer's cart using Rebuy Smart Cart API, but suppress the cart opening.
        if (clearCart) {
            Rebuy.Cart.clearCart();
        }
        fetch('/collections/store?view=stock')
        .then(response => response.json())
        .then(data => {
            let products = data.products;  // Get the products from the API response
            let cartTotal = 0;
            let cartItems = [];

            // Shuffle the product array to randomize the selection order
            products = shuffleArray(products);

            let uniqueProductsAdded = new Set();  // Track unique items added
            let productIndex = 0;

            // Step 3: Add unique products randomly to the cart until totalAmount is met
            while (cartTotal < totalAmount) {
                let product = products[productIndex];
                let productPrice = parseFloat(product.price);

                // If all unique products have been added, restart from the beginning (allow repetition)
                if (productIndex >= products.length) {
                    productIndex = 0; // Restart the loop to allow repetitions of products
                }

                // Add the product only if it hasn't been added yet or if we have exhausted all unique products
                if (!uniqueProductsAdded.has(product.id) || productIndex >= products.length) {
                    cartItems.push({
                        id: product.variants[0].id,  // Use the variant ID to add to cart
                        quantity: 1,
                        properties: {
                            _source: 'Shuffle',
                            _attribution: 'Banner'
                        }  // Add line item properties here
                    });

                    cartTotal += productPrice;
                    uniqueProductsAdded.add(product.id);  // Mark this product as added
                }

                productIndex++;
            }

            // Step 4: Add all selected items to the cart at once via Shopify's cart API
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: cartItems  // Send all cart items in a single API call
                })
            });
        })
        .then(() => {
            // Step 5: Reveal the Rebuy Smart Cart after all items are successfully added
            Rebuy.SmartCart.skip_open = false;
            //Rebuy.SmartCart.show();
            // Hide spinner and show success or handle any next steps
            aiProcessing = false;

        })
        .catch(error => {
            console.error('Error adding items to cart:', error);
        });
    }
}

document.addEventListener('rebuy:smartcart.show', (event) => {
    
});

document.addEventListener('rebuy:cart.enriched', (event) => { 
    if (!aiProcessing && aiLoading) {
        aiLoading = false;
        document.getElementById('snack-roulette-spinner').style.display = 'none';  // Hide spinner
        document.getElementById('snack-roulette-modal-header').style.display = 'block';
        document.getElementById('snack-roulette-modal-description').style.display = 'block';
    }
  });

const slider = document.getElementById('priceSlider');
  const sliderValue = document.getElementById('sliderValue');
  const progressBar = document.getElementById('progressBar');

  const milestone50 = document.getElementById('milestone50');
  const milestone75 = document.getElementById('milestone75');
  const milestone100 = document.getElementById('milestone100');
  const milestone200 = document.getElementById('milestone200');

  // Function to initialize everything on page load
  // Function to initialize everything on page load
  function initialize() {
    const value = slider.value; // get current slider value on load (should be 100 now)
    sliderValue.textContent = value;

    updateProgressBar(value);
    unlockMilestones(value);
  }

  // Update the slider value display and progress bar on input
  slider.addEventListener('input', function () {
    const value = slider.value;
    sliderValue.textContent = value;

    updateProgressBar(value);
    unlockMilestones(value);
  });

  // Function to update the progress bar based on slider value
  function updateProgressBar(value) {
    let progressPercentage = (value / 200) * 100;

    if (value < 75) {
      progressBar.style.width = '0%';
    } else if (value >= 75 && value < 100) {
      progressBar.style.width = '10%'; // Progress to first milestone
    } else if (value >= 100 && value < 150) {
      progressBar.style.width = '36%'; // Progress to second milestone
    } else if (value >= 150 && value < 200) {
      progressBar.style.width = '63%'; // Progress to third milestone
    } else if (value >= 200) {
      progressBar.style.width = '100%'; // Full progress at fourth milestone
    }
  }

  // Function to unlock the milestones based on slider value
  function unlockMilestones(value) {
    milestone50.classList.remove('unlocked');
    milestone75.classList.remove('unlocked');
    milestone100.classList.remove('unlocked');
    milestone200.classList.remove('unlocked');

    if (value >= 75) milestone50.classList.add('unlocked');
    if (value >= 100) milestone75.classList.add('unlocked');
    if (value >= 150) milestone100.classList.add('unlocked');
    if (value >= 200) milestone200.classList.add('unlocked');
  }

  // Initialize everything when the page loads
  window.addEventListener('DOMContentLoaded', initialize);

  // Hooking up the start button
document.getElementById('generateSnacksButton').addEventListener('click', function() {
    const selectedAmount = parseInt(slider.value);  // Get the slider value
    const clearCart = document.getElementById('clearCartFirt').checked;
    dataLayer.push({'event': 'generateAiCart', 'label': slider.value });
    generateCart(selectedAmount, clearCart);  // Call generateCart with the selected amount
});